/**
 * Klaviyo onsite queue (`_learnq`) — same event names / payloads as the prior theme.
 */

/**
 * @param {ParentNode | null | undefined} scope
 * @returns {Record<string, unknown> | null}
 */
export function readKlaviyoLearnqProduct(scope) {
  if (!scope) {
    return null;
  }
  const el = scope.querySelector(
    'script[type="application/json"][data-klaviyo-learnq-product]',
  );
  if (!el?.textContent?.trim()) {
    return null;
  }
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

/**
 * @param {Record<string, unknown> | null | undefined} item
 */
export function trackKlaviyoAddedToCart(item) {
  if (!item || typeof item !== 'object') {
    return;
  }
  window._learnq = window._learnq || [];
  window._learnq.push(['track', 'Added to Cart', item]);
}

/**
 * @param {Record<string, unknown> | null | undefined} item
 */
export function trackKlaviyoViewedProduct(item) {
  if (!item || typeof item !== 'object') {
    return;
  }
  window._learnq = window._learnq || [];
  window._learnq.push(['track', 'Viewed Product', item]);
}

/**
 * Klaviyo `trackViewedItem` — separate from `track('Viewed Product')`; shape matches legacy theme.
 *
 * @param {Record<string, unknown> | null | undefined} item - Same object as Added to Cart / Viewed Product (Name, ProductID, ImageURL, …)
 */
export function trackKlaviyoViewedItem(item) {
  if (!item || typeof item !== 'object') {
    return;
  }
  const payload = {
    Title: item.Name,
    ItemId: item.ProductID,
    Categories: item.Categories,
    ImageUrl: item.ImageURL,
    Url: item.URL,
    Metadata: {
      Brand: item.Brand,
      Price: item.Price,
      CompareAtPrice: item.CompareAtPrice,
    },
  };
  window._learnq = window._learnq || [];
  window._learnq.push(['trackViewedItem', payload]);
}
